/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Tilbage",
      "<h3 class=”header-3”>Tilgængelighedsstatus</h3> <p>EU's tilgængelighedsdirektiv forpligter os til at designe vores e-handelstjenester (herunder identifikations- og betalingsmetoder) med tilgængelighed i tankerne, så de er letgennemskuelige, driftssikre, forståelige og robuste. Derudover stræber vi efter at designe vores hjemmesider og mobilapplikationer i overensstemmelse med <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C's retningslinjer for tilgængeligt webindhold (WCAG) 2.1, niveau AA</a>. For at opnå disse mål har vi: </p> <ul> <li>Startet et partnerskab med tilgængelighedskonsulenter som Level Access for at forstå, hvordan vi kan gøre vores services mere tilgængelige.</li> <li>Evalueret vores digitale oplevelser ud fra globale tilgængelighedsstandarder.</li> <li>Lært af en bred vifte af eksperter inden for tilgængeligehed, herunder brugere med handicap og yderligere tilgængelighedsbehov.</li> </ul>",
      "<h3 class=”header-3”>Feedback og kontakt</h3> <p>Selvom vi stræber efter at sikre tilgængelighed for alle brugere, kan der være visse begrænsninger. Vi vil meget gerne have feedback til at forbedre os, så hvis du støder på tilgængelighedsbarrierer eller har brug for information i et alternativt format, kan du kontakte os på accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Fremtidige forbedringer</h3> <p>Vi arbejder løbende på at forbedre vores tilgængelighed. Vi vil fortsat:</p> <ul> <li>Overvåge og evaluere adgang til alle digitale platforme.</li> <li>Løse kendte problemer og forhindre fremtidige barrierer ved at designe med tilgængelighed i tankerne.</li> <li>Udvide intern træning og kendskab for at forbedre inkluderende designs.</li> </ul>",
      "<h3 class=”header-3”>Sidst opdateret: november 2025</h3>",
      "<h3 class=”header-3”>Foranstaltninger, der er taget</h3> <p>For at opnå tilgængelighed på vores tjenester har vi:</p> <ul> <li>Indgået et partnerskab med Level Access for at udføre omfattende evalueringer og få vejledning inden for tilgængelighed.</li> <li>Integreret tilgængelighedsværktøjer på vores platforme, herunder hjælpemidler såsom tastaturalternativer, taleaktivering og berøringsfri navigation.</li> <li>Udført brugertest med personer med handicap for at indsamle reel feedback og informere om forbedringer.</li> <li>Integreret tilgængelighedsovervejelser i vores produktudviklingslivscyklus og kvalitetssikringsprocesser.</li> <li>Etableret et digitalt tilgængelighedsprogram på tværs af organisationen.</li> <li>Implementeret en <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">hjælpeplatform til kundeoplevelser</a>. Denne er gratis og tilgængelig for personer, der har problemer med at skrive, gestikulere, bevæge en mus eller læse. Den indeholder værktøjer som erstatning for mus og tastatur, stemmegenkendelse, taleaktivering, håndfri/berøringsfri navigation og meget mere.</li> </ul>",
      "<h3 class=”header-3”>Vores politik</h3> <p>Hos Bumble er ligeværdighed en af vores vigtigste værdier. Det er meget mere end et buzzord for os – vi stræber efter at gøre Bumble-oplevelser tilgængelige, retfærdige og ligeværdige.</p> <p>Denne tilgængelighedserklæring er blevet udviklet for at informere vores brugere om tilgængeligheden af vores tjeneste, inklusive overensstemmelse med relevant lovgivning og tekniske standarder. Denne tilgængelighedserklæring gælder for de dele af vores tjenester [RS2], der er dækket af EU's tilgængelighedsdirektiv, særligt vores e-handelstjenester, der gør det muligt for brugere at opgradere til en række forbedrede, premium Bumble-funktioner. Disse tjenester kan tilgås gennem Bumble-appen.</p>",
      "EU's tilgængelighedsdirektiv",
      "Download på App Store",
      "Få den på Google Play",
      "Karrusel",
      "Slide {{number}}",
      "Næste slide",
      "Forrige slide",
      "Slide",
      "Slide {{number}} af {{total}}",
      "Sælg eller del ikke mine personlige oplysninger",
      "Sælg eller del ikke mine personlige informationer",
      "Brug Compliments på Bumble for at vise, at du synes godt om deres profil, og fang deres opmærksomhed før I matcher. Prøv det nu",
      "Compliments | Sådan sender du et kompliment | Bumble",
      "En personlig side, der fremhæver de personer, som du har mest tilfælles med, opdateret dagligt.",
      "Udforsk | Find kompatible personer | Bumble",
      "Dato i dit eget tempo, og hav kontrol over, hvem der ser din Bumble-profil med Inkognito-tilstand. Lær mere om at bruge Inkognito-tilstand på Bumble i vores guide",
      "Inkognito-tilstand | Skjul din profil | Bumble",
      "Efter at have mødt hinanden til et fysisk Bumble-event, kan I bygge videre på den gode kemi i en samtale i appen.",
      "Match øjeblikkeligt | Hold samtalen kørende i appen | Bumble",
      "Har du brug for en pause? Find ud af, hvordan du sætter din Bumble-konto på pause med Bumbles Snooze-tilstand. Den giver dig mulighed for at date på din måde",
      "Snooze-tilstand | Sæt din konto på pause | Bumble",
      "Har du lige set en, du virkelig kan lide på Bumble? Brug et SuperSwipe for at vise dem, at du er interesseret. Tryk på stjernen på deres profil for at begynde, eller se flere oplysninger her",
      "Bumble SuperSwipe | Hvad er et SuperSwipe? | Bumble",
      "Skal du rejse på grund af arbejde eller fornøjelse? Rejse-tilstand på Bumble kan hjælpe dig med at få spændende nye forbindelser et nyt sted, så du kan date hvor som helst. Udforsk Rejse-tilstand her",
      "Rejse-tilstand på Bumble | Date hvor som helst | Bumble",
      "Vil du finde ud af, om jeres kemi i beskederne også kan overføres til den virkelige verden? Prøv en videochat eller et stemmeopkald på Bumble nu, og bliv klogere på jeres vibe",
      "Videochat | Lav et opkald | Bumble",
      "Bumble Date",
      "Vores apps",
      "Om",
      "Karriere",
      "Kontakt os",
      "Investorer",
      "Shoppen",
      "Virksomheden",
      "Download appen",
      "Tilgængelighed på Bumble",
      "Retningslinjer",
      "Administrer cookies",
      "Modern Slavery act",
      "Meddelelse ved indsamling",
      "Privatlivspolitik",
      "Vilkår og betingelser",
      "Juridisk",
      "Washington Consumer Health Privacy Policy",
      "Scan QR-koden for at hente Bumble-appen",
      "Log ind",
      "Opsig kontrakter her",
      "Download nu",
      "Scan QR-koden for at komme i gang.",
      "Find din næste date",
      "Få appen",
      "Bumble startside",
      "Luk menu",
      "Åbn menu",
      "Kommer snart: Kærlighedshistorier fra Bumble",
      "Vælg dit sprog",
      "Sprogvalg",
      "Footer",
      "Adgang til Bumble",
      "Apple og Apple-logoet er varemærker tilhørende Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Jobmuligheder",
      "Begivenheder",
      "Google Play er et varemærke tilhørende Google LLC.",
      "Retningslinjer",
      "Investorer",
      "Administrer cookies",
      "Administrer cookies",
      "Modern Slavery Act Statement",
      "Meddelelse ved indsamling",
      "Privatlivspolitik",
      "Sæsonbestemte datingguides",
      "Vilkår & betingelser",
      "Appen",
      "Privatlivspolitik for Consumer Health Data i Washington",
      "Om",
      "Ambassadører",
      "Få nye venner, og find et fællesskab",
      "Skab netværk, og gør fremskridt i din karriere",
      "Find et forhold, noget uforpligtende eller noget derimellem",
      "The Buzz",
      "Se mere",
      "Bliv global med Rejse-tilstand",
      "Date",
      "Begivenheder",
      "Funktioner",
      "Compliments",
      "Send Compliments til dem for at gøre dig ekstra bemærket.",
      "Udforsk",
      "En personlig side, der fremhæver de personer, som du har mest tilfælles med, opdateret dagligt.",
      "Inkognito-tilstand",
      "Brug Inkognito-tilstand for at skjule din profil for din chef, familie eller ekskærester.",
      "Match øjeblikkeligt",
      "Fik I gang i samtalen til et fysisk Bumble-event? Fortsæt snakken på appen.",
      "Snooze-tilstand",
      "Sæt dating på pause med Snooze-tilstand. Når du er klar til at date igen, ved du, hvor vi er.",
      "SuperSwipe",
      "Var du vild med profilen? Fortæl dem det med et SuperSwipe.",
      "Rejse-tilstand",
      "Find din rejsesnack, og match over hele verden med Rejse-tilstand.",
      "Videochat",
      "Brug videochat og audioopkald for at se, om I er klar til at mødes i den virkelige verden.",
      "Gå til Bumble-appen",
      "BFF",
      "Sikkerhed",
      "Historier",
      "Support",
      "Shoppen",
      "Primære",
      "Send komplimenter for at gøre dig ekstra bemærket.",
      "Compliments",
      "Funktioner designet til at skabe ægte, respektfulde og meningsfulde relationer.",
      "Skjul din profil fra din chef, familie eller ekskæreste.",
      "Inkognito-tilstand",
      "Tag en pause fra dating med Snooze-tilstand.",
      "Snooze-tilstand",
      "Er der en, du godt kan lide? Giv besked.",
      "SuperSwipe",
      "Udforsk Date",
      "Pak kufferten, og match hvor som helst.",
      "Rejse-tilstand",
      "Kom så tæt på IRL som muligt uden at tage hjemmefra.",
      "Videoopkald",
      "Få Bumble-oplevelsen direkte i din browser.",
      "Webapp",
      "Vores ambassadører hjælper med at bringe Bumbles værdier ind i fællesskaber over hele landet.",
      "Ambassadører",
      "Funktioner designet til at hjælpe dig med at finde dine personer og skabe kontakt over fællesinteresser.",
      "Organisér et meetup, eller udforsk lokale events i nærheden.",
      "Plans",
      "Udforsk BFF",
      "Al den vejledning og inspiration, du har brug for i din søgen efter kærlighed og venskaber.",
      "Råd og historier til at hjælpe dig med at opbygge ægte venskaber.",
      "Hub for venskaber",
      "Fra Tokyo til Toronto: Udforsk kærlighed fundet på Bumble verden over.",
      "Kærlighedshistorier",
      "Plan den perfekte date – uanset hvornår, hvor og med hvem.",
      "Sæsonbestemte datingguides",
      "Udforsk historier",
      "Spring over til primært indhold",
      "Bumble-logo",
      "Luk navigationsmenu",
      "Åbn navigationsmenu",
      "Portræt af Whitney Wolfe Herd, grundlægger og CEO af Bumble",
      "Whitney Wolfe Herd grundlagde Bumble med ét mål: at opbygge det mest tillidsvækkende rum til at finde kærlighed, hvor kvinder tager det første skridt, og relationer er baseret på respekt.{{__EOL__}}{{__EOL__}}Som CEO går hun stadig forrest med samme overbevisning: at finde kærlighed online skal føles meningsfuldt, trygt og autentisk. Bumble handler om mere end dating. Det handler om at hjælpe mennesker med at finde noget meningsfuldt med fokus på tryghed, intention og empati. Det betyder blandt andet, at vi bruger AI og teknologi til at understøtte menneskelig kontakt – ikke erstatte den. Vi bruger alt, hvad vi har lært – det gode, det uperfekte og det ærlige – så hele vores fællesskab fortsat føler sig velkommen på Bumble.",
      "Whitney Wolfe Herd",
      "Smilende par, der skal til at kysse og holder hånd på bagsædet af en bil med grønne omgivelser udenfor.",
      "Vi tror, at kærlighed – i alle dens former – er grundlaget for et sundt og lykkeligt liv.",
      "Hej. Vi er Kærlighedsvirksomheden.",
      "Bumble-matchskærm med to profiler og en prompt til at starte samtalen.",
      "Resultatet? En platform med fokus på medlemmerne og på at opbygge gode relationer.",
      "I {{date}} omskrev vi datingreglerne.",
      "Vores mission er at få folk tættere på kærlighed.",
      "Vores mission",
      "Vi vendte op og ned på datingnormerne, og lod kvinderne tage det første skridt.",
      "Bumble ser dagens lys",
      "{{bff}} blev lanceret for at hjælpe folk med at finde deres crew. Fordi kærlighed også kan være helt platonisk.",
      "Mere end dating",
      "Serena Williams hjalp os med at bringe kvinder, der tager det første skridt, til Super Bowl.",
      "Debut med Super Bowl",
      "Vi lancerede nye funktioner til at navigere dating under Covid-19-pandemien.",
      "Dates blev virtuelle",
      "Vi blev børsnoteret – ledet af den yngste kvinde til nogensinde at gøre det.",
      "Der blev skabt historie",
      "Sammen med vores anti-cyberflashingteknologi udvidede vi vores politikker for at beskytte kvinder.",
      "Bedre sikkerhed",
      "Vi satte rampelys på kvinders sport, så den lyste op som fortjent.",
      "WNBA x Bumble",
      "V bygger nu en fremtid, hvor kærlighed føles opnåelig for alle.",
      "Bruger kærlighed som kompas",
      "Vi startede med et vovet skridt. I dag bygger vi det mest tillidsvækkende og effektive sted at finde kærlighed.",
      "Scroll for at udforske",
      "Scroll til venstre",
      "Scroll til højre",
      "Vores historie",
      "Se vores ledige stillinger",
      "Hjælp os med at skabe det mest pålidelige sted at finde kærlighed.",
      "Kom og vær med",
      "BFF-skærmbilleder fra app, der understreger brugerprofilvisning og interessebadges til at skabe forbindelse med venner",
      "Uanset om du er flyttet til en ny by eller bare vil udvide din vennekreds, gør {{bff}} det let at møde folk, der matcher din energi.",
      "Find dit crew",
      "Collage af Bumble-profiler, der viser en mangfoldighed af personer med badges med ID-verificering, inklusive en kvinde, der tager en spejlselfie i midten.",
      "Uanset om du er ny i dating eller klar til at prøve igen, er Bumble Date bygget til at bringe dig tættere på kærligheden på en tryg og meningsfuld måde.",
      "Find din person",
      "Smilende kvinde bærer et skateboard i en park",
      "Outdoor",
      "Mand jogger og smiler i en bypark",
      "Løb",
      "Kvinde holder en lille plysset hund udendørs",
      "Hundeforælder",
      "Download Bumble",
      "Vi vil gerne have, at vores medlemmer skaber meningsfulde og autentiske relationer, der bygger på tillid og glæde.",
      "Vi er her for at bringe folk tættere på kærlighed.",
      "Kvinde med lang mørk hestehale, sort top og solbriller i håret står smilende med havet bag sig.",
      "Skægget mand i mønstret skjorte holder et kamera, mens han står udendørs med træer og bygninger i baggrunden.",
      "Kvinde har en rød regnbuestribet jakke, sølvfarvede hovedtelefoner og en grøn stjernehalskæde på, mens hun ser direkte ind i kameraet.",
      "Smilende par, der omfavner hinanden i et sort-hvidt portræt",
      "{{name1}} & {{name2}}, gift i {{num}}",
      "Se mere",
      "Læs flere historier",
      "\"{{__EOL__}}Vi er begge positive af natur og går efter vores drømme, men sammen føles det som om, at vi kan opnå hvad som helst.",
      "To personer griner på en tennisbane, og en holder tennisbolde foran øjnene",
      "Mød hinanden IRL",
      "Bumble-events betyder, at du kan stoppe med at skrive og begynde at snakke. Kom alene, eller tag en ven med – og skab en ny forbindelse.",
      "Start chatten ansigt til ansigt",
      "Mennesker nyder at skabe forbindelser på Bumble gennem billeder, videochats og ekspertråd.",
      "Tilmeld dig",
      "Vær med til at forme fremtiden for Bumble ved at blive medlem af vores Medlemscirkel. Dette udvalgte fællesskab af medlemmer deler ideer direkte med vores team via chats, diskussioner og produkttests.{{__EOL__}}{{__EOL__}}Deltagere får tidlig adgang til nye funktioner, smugkig på kommende kampagner og muligheden for at hjælpe med at gøre Bumble endnu bedre for alle.",
      "Del dine ideer",
      "Vil du lære personen at kende? Brug videochat på Bumble",
      "Tryk blot på videoikonet i din chat for at starte et videoopkald – helt uden at dele nogen personlige kontaktoplysninger.",
      "Hvordan fungerer videochat på Bumble?",
      "Nej. Alle opkald og chats på Bumble holder dine personlige oplysninger sikre. Ingen matches vil få dit nummer eller andre kontaktoplysninger, før du selv deler dem.",
      "Vil mit match kunne se mit telefonnummer?",
      "Helt bestemt! Hvis du ikke er klar til at mødes ansigt til ansigt, kan I mødes via audioopkald. Vælg blot ringeikonet i stedet for.",
      "Kan jeg nøjes med et audioopkald?",
      "Vi elsker at få en notifikation om en *modtaget besked*. Men det kan være svært at vide, om den gode kemi fra en chat kan overføres til virkeligheden. Det er her video- og audioopkald kommer ind i billedet.",
      "Videochat på Bumble",
      "<a href={{video_chat_url}}>Videochats og audioopkald</a> kan hjælpe jer med at lære hinanden at kende og finde ud af, om I vil mødes personligt. Det bedste ved det hele? Når I ringer sammen igennem Bumble, behøver I ikke at udveksle telefonnumre, og jeres personlige oplysninger forbliver sikre, indtil I er klar til at dele dem.",
      "Tjek jeres kemi med en videochat",
      "Byg bro mellem online- og offline-dating, og beslut, om det er tid til at mødes i virkeligheden.",
      "Lær dem bedre (og hurtigere) at kende. En samtale ansigt til ansigt på telefonen kan afsløre meget om en person.",
      "Du har kontrollen. Vi holder dine kontaktoplysninger private, så du kan vælge, hvornår du vil dele dem.",
      "Se, om du er klar til at mødes personligt",
      "Tjek hurtigt stemningen",
      "Skab forbindelse uden at dele dine personlige oplysninger",
      "Derfor er videochats og -opkald en god idé",
      "Klar til at starte en samtale? Du kan vælge, om du vil starte et audioopkald eller et videoopkald direkte fra din chat i Bumble-appen. For at starte et videoopkald skal du trykke på det grå videoikon i øverste højre hjørne. Du vil også se tre prikker ved siden af ikonet, og når du klikker på dem, vil du også se muligheden for at lave et audioopkald.",
      "Sådan starter du en videochat",
      "Klar til at prøve Compliments?",
      "Når du sender et kompliment, vil personen, der modtager det, se det, når du dukker op i deres kø.",
      "Hvad sker der, når du sender et kompliment til en person på Bumble?",
      "Hvis komplimentet fanger din opmærksomhed, kan du gøre afsenderen til et match. Du kan se komplimentet i jeres chat, og de sædvanlige regler for at <a href={{make_the_first_move_url}}>tage det første skridt</a> gælder stadig.",
      "Hvordan svarer jeg på et kompliment?",
      "Du kan sende {{num}} [[Compliments:num]] gratis. Når du løber tør, kan du købe flere i Bumble-appen i pakker på op til 30. En af disse vil blive brugt til at sende komplimentet (gem resten til du ser en anden profil, du finder interessant). Bare rolig, de udløber ikke!",
      "Hvor mange komplimenter kan jeg sende?",
      "Man kan komme langt med et venligt ord (eller to). Hvis du vil sende et kompliment, men ikke ved, hvad du skal skrive, så kan du blive inspireret af disse:",
      "Se flere eksempler",
      "\"Alle, der elsker [kunstnerens navn], har god smag.\"",
      "\"Dit smil er smittende!\"",
      "\"Din bio fik mig til at grine. Godt lavet.\"",
      "Sådan sender du bedre komplimenter på Bumble",
      "Vil du gøre nogens dag bedre? Det lyder til, at du er klar til at bruge Compliments.",
      "Compliments på Bumble",
      "Brug Compliments på Bumble for at fortælle et potentielt match, at du kan lide deres profil (og få dem til at rødme!). Du får Compliments som en del af dit {{service_level_lexeme_name}}-medlemskab. Det gør det også muligt at sende og modtage beskeder, før I matcher.",
      "Sådan fungerer Compliments",
      "Når du modtager et kompliment, vil det blive vist på afsenderens profil. Du får også en notifikation, der fortæller dig, at nogen er vild med noget fra din profil.",
      "Se dine komplimenter",
      "Du kan sende et kompliment ved at trykke på det gule hjerteikon nederst på en persons profil. Det er vigtigt, hvor du præcist trykker, fordi du sender et kompliment til det specifikke billede eller den specifikke del af profilen. Når du klikker, åbnes en tekstboks, så du kan skrive din besked (den kan være på maks. 150 tegn).",
      "Send et kompliment",
      "DOWNLOAD Bumble FOR AT PRØVE UDFORSK",
      "Hver dag fra kl. 9 kan du se nye personer i Udforsk. Du kan skabe kontakt til dem ud fra de ting, I har tilfælles.",
      "Hvornår bliver Udforsk opdateret?",
      "I Udforsk bliver potentielle matches opdelt i 3 hovedkategorier: lignende interesser, samme datingmål og delte fællesskaber. Profilanbefalinger bliver også vist baseret på dine tidligere matches.",
      "Hvordan bliver folk i Udforsk udvalgt?",
      "En personlig side, der fremhæver de personer, som du har mest tilfælles med, opdateret dagligt",
      "FIND PERSONER, SOM MATCHER DIN ENERGI MED {{qr_code}} UDFORSK",
      "Udforsk viser dig et udvalg af personer, som vi tror, du vil synes om – baseret på fælles interesser, datingmål og fællesskaber.",
      "Prøv Udforsk",
      "SØGER DU EN NY MÅDE AT FINDE ET FÆLLES UDGANGSPUNKT PÅ?",
      "Udforsk bliver opdateret hver dag, så du ser endnu flere personer, du passer godt med — det betyder mindre tid på at søge efter et match og mere tid på at komme tættere på de personer, du har god kemi med.",
      "ANBEFALINGER OPDATERES DAGLIGT",
      "Anbefalingerne i Udforsk er baseret på din profil, og hvem du har matchet med før, så du vil se personer, der kan lide de samme ting som dig og er på udkig efter det samme – uanset om det er opskrifter med plantefars eller et seriøst forhold.",
      "PERSONLIGT TILPASSET{{__EOL__}}TIL DIG",
      "Download Bumble",
      "Ofte stillede spørgsmål",
      "Klar til at browse Bumble anonymt?",
      "Når du aktiverer Inkognito-tilstand, vil du ikke blive vist til andre Bumble-medlemmer, medmindre du giver deres profil et like.",
      "Hvordan fungerer Inkognito-tilstand?",
      "Uden Inkognito-tilstand er din profil synlig for andre på Bumble, når du passer til deres præferencer som alder og lokation. Når du aktiverer Inkognito-tilstand, vil du kun være synlig for personer, når du har givet dem et like.",
      "Hvem kan se mig i Bumbles Inkognito-tilstand?",
      "Brug af Inkognito-tilstand er ikke det samme som at <a href={{blocking_on_bumble_url}}>blokere nogen på Bumble</a>. Med denne funktion kan personer stadig se din profil, hvis du har givet dem et like, eller hvis du har skrevet til dem tidligere.",
      "Er Inkognito-tilstand det samme som at blokere nogen?",
      "Få kontrol over, hvem der ser din profil med Inkognito-tilstand på Bumble.",
      "Inkognito-tilstand på Bumble",
      "Hvis du vil tage en pause fra dating, eller browse Bumble uden at andre kan se din profil, kan du skifte til Inkognito-tilstand. Når du slår denne funktion til, betyder det, at vi skjuler dig fra alle – medmindre du har givet dem et like. Det gør, at du kan tage kontrol over, hvad du deler, og hvem der kan se dig.",
      "Skjul din profil med Inkognito-tilstand",
      "Du bestemmer, hvem der kan se dine billeder og personlige oplysninger.",
      "Vil du dele noget personligt på din profil? Du kan diskret dele, hvad du vil, med dine nuværende matches.",
      "Browse uden at være bekymret for at ramme ind i din ex, en kollega eller andre, der ikke er på din dating-radar.",
      "Tag fuld kontrol",
      "Vælg, hvad du vil dele",
      "Undgå akavede øjeblikke",
      "Derfor vil du elske Inkognito-tilstand",
      "Inkognito-tilstand er tilgængelig for medlemmer med {{service_level_lexeme_name}} og {{service_level_lexeme_name_two}}. Når du har tilmeldt dig, kan du slå det til ved at gå til din profilfane, trykke på indstillinger i øverste højre hjørne og skifte til Inkognito-tilstand.",
      "Opgrader til {{service_level_lexeme_name}}",
      "Sådan bruger du Inkognito-tilstand på Bumble",
      "DOWNLOAD Bumble FOR AT PRØVE \"MATCH ØJEBLIKKELIGT\" I DAG",
      "I Bumble-appen skal du gå til profilikonet nederst på skærmen. Herfra finder du QR-kodeikonet øverst til højre på skærmen. Tryk for at få adgang til den.",
      "Hvor kan jeg finde min personlige QR-kode?",
      "Nej! Du skal være forbundet til internettet, enten via mobildata eller wi-fi, og bruge den aktuelle QR-livekode for, at Match øjeblikkeligt virker.",
      "Kan jeg dele min QR-kode med et skærmbillede?",
      "Nej! Hvis en person scanner koden, vil I blive matchet automatisk.",
      "Skal begge personer scanne QR-koden?",
      "Med Match øjeblikkeligt kan du automatisk se, hvad du og dit nye match har tilfælles – og få et indblik i, hvordan I passer sammen med det samme.",
      "FIND ET FÆLLES UDGANGSPUNKT, HURTIGERE",
      "Fik I gang i samtalen til et fysisk Bumble-event? Fortsæt snakken på appen.",
      "ET HYGGELIGT MØDE FORVANDLES TIL ET {{qr_code}} ØJEBLIKKELIGT MATCH",
      "Match øjeblikkeligt gør det nemt at fortsætte samtalen med en sød person, du lige har mødt – uden at udveksle numre eller sociale profiler. Når vedkommende scanner din QR-kode, matcher I på Bumble.",
      "Prøv Match øjeblikkeligt",
      "HAR DU MØDT NOGEN TIL ET FYSISK Bumble-EVENT?",
      "Frem for at udveksle sociale profiler eller telefonnumre, gør Match øjeblikkeligt det muligt at undersøge kemien i appen først. På den måde kan I bedre lære hinanden at kende på jeres måde, takket være Bumbles række af sikkerhedsfunktioner.",
      "KONTAKT PÅ EN MERE SIKKER MÅDE",
      "Efter at have mødt hinanden til et fysisk Bumble-event, kan I bygge videre på kemien ved at fortsætte samtalen i appen og tale om fælles interesser, fx den perfekte kop kaffe eller en sjælden plante.",
      "HOLD SAMTALEN KØRENDE",
      "Vil du have en pause? Prøv Snooze-tilstand",
      "Ja, du kan gå til dine indstillinger eller din kø, og slå Snooze fra på ethvert tidspunkt.",
      "Kan jeg deaktivere Snooze-tilstand tidligere?",
      "Gå til indstillinger, tryk på Snooze, og vælg, hvor længe du vil være væk. Kom tilbage, når du er klar.",
      "Hvordan bruger jeg Snooze-tilstand på min profil?",
      "Nej, i Snooze-tilstand er al swipe- og chataktivitet sat på pause. Hvis du vil se nye personer, vil du se en besked, der fortæller dig, hvor lang tid du stadig er i Snooze-tilstand, og der vil være en mulighed for at deaktivere den.",
      "Kan jeg stadig udforske profiler og chatte i Snooze-tilstand?",
      "De personer, som du allerede har skrevet med, vil kunne se din \"Væk\"-status (hvis du indstiller den). Ellers vil de kunne se jeres tidligere beskeder i indbakken som normalt.",
      "Hvad vil nuværende matches se, når jeg er i Snooze-tilstand?",
      "Du har total kontrol over din Bumble-aktivitet og kan trække dig tilbage fra platformen, når du har lyst til det.",
      "Du kan opdatere eksisterende forbindelser ved at bruge din statusopdatering, så det ikke ligner, at du <a href={{ghosted_article_url}}>ghoster dem</a>. Derudover er det hele automatiseret – så du ikke behøver at sende nogen beskeder.",
      "Tag en pause fra aktiv dating uden at miste dine forbindelser eller chats.",
      "Date (eller afbryd forbindelsen) på din måde",
      "Hold dine forbindelser opdateret",
      "Sæt din aktivitet på pause – ikke dine forbindelser",
      "Derfor elsker vi Snooze-tilstand",
      "Åbn Bumble-appen, gå til din profilfane, og tryk på indstillingshjulet øverst til højre. I indstillingerne trykker du på Snooze og vælger, hvor lang tid du vil være væk. Du kan skjule din profil i 24 timer, 72 timer, en uge eller uendeligt.{{__EOL__}}{{__EOL__}}Husk, at matches uden aktive chats udløber, når du er i Snooze-tilstand. Hvis du beslutter dig for at sætte en status, kan personer, som du chatter med i øjeblikket, se, at du er væk.",
      "Sådan fungerer Snooze-tilstand på Bumble",
      "Når livet bliver hektisk, kan Snooze-tilstand være en hjælp. Sæt din Bumble-konto på pause, og skab dine egne datingregler.",
      "Snooze-tilstand på Bumble",
      "Snooze-tilstand er en nem måde at sætte din konto på pause på, når du har brug for at trække dig lidt væk fra datingverdenen. Du kan fortsat chatte med dine eksisterende forbindelser, men din profil bliver skjult for andre, indtil du er klar igen. Du mister ikke dine profiloplysninger eller sletter eksisterende forbindelser ved at aktivere Snooze-tilstand.",
      "Snooze din Bumble-profil",
      "I Snooze-tilstand kan du vælge at give eksisterende forbindelser besked om, at du tager en pause, ved at opdatere din status. Vælg mellem \"Jeg er ude at rejse\", \"Jeg er optaget af arbejde\", \"Jeg er på en digital detox\" eller \"Jeg prioriterer mig selv\". Du kan vælge den status, der passer bedst til din vibe.",
      "Tilføj en \"Væk\"-status",
      "Når du aktiverer Snooze-tilstand, sætter du din Bumble-konto (eller {{page_partner_name_bff}}-konto) på pause. Dine matches ved ikke, at du er i Snooze-tilstand, medmindre du fortæller dem det. Hvis du beslutter dig for at vågne op fra din Snooze-tilstand tidligere end forventet, så trykker du bare på \"Deaktiver Snooze-tilstand\" i indstillingerne. Hvor nemt kan det være?",
      "Sæt dine chats på pause",
      "Prøv SuperSwipe på Bumble",
      "Så mange du vil! {{service_level_lexeme_name}}-brugere får {{num}} [[superswipe:num]] hver uge, men du kan fylde din saldo op på ethvert tidspunkt. Gratismedlemmer kan købe pakker af SuperSwipes.",
      "Hvor mange SuperSwipes kan jeg sende på Bumble?",
      "Når nogen bruger et SuperSwipe på din profil, får du straks besked. Du vil også se et label over personens navn på deres profil, så du kan se, at vedkommende kan lide dig.",
      "Hvordan ved jeg, om nogen gav mig et SuperSwipe?",
      "Er du virkelig interesseret i en? Der er en cool måde at bryde isen på: Send blot et SuperSwipe for at vise dem, at du er interesseret, og kom hurtigere til de gode samtaler!",
      "SuperSwipe på Bumble",
      "Det er ikke altid nemt at skille sig ud fra mængden, men SuperSwipe kan hjælpe dig med at gøre et godt førstehåndsindtryk.{{__EOL__}}{{__EOL__}}Når du bruger et SuperSwipe, bliver der sendt en notifikation til den pågældende person. Du kommer derefter forrest i køen hos personen og har et label på din profil. Hvis vedkommende også er interesseret i dig, er det tid til at starte en chat.",
      "Hvad er et SuperSwipe?",
      "Vær modig, og skil dig ud",
      "Start flere samtaler",
      "Skab flere forbindelser",
      "SuperSwipe hjælper dig",
      "Hvis du har <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> eller Bumble {{service_level_lexeme_name_one}}, får du {{num}} gratis [[superswipe:num]] om ugen. Derudover kan alle medlemmer købe pakker af op til {{num_two}} [[superswipe:num_two]] under profilfanen. Hvis du har {{service_level_lexeme_name_three}}, får du {{num_three}} [[superswipe:num_three]] om ugen.{{__EOL__}}{{__EOL__}}Det er nemt at bruge SuperSwipe – hvis du er interesseret i en person, trykker du bare på det gule stjerneikon nederst på vedkommendes profil.",
      "Sådan bruger du SuperSwipe",
      "Date på farten med Rejse-tilstand på Bumble",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}}-medlemmer</a> kan benytte Rejse-tilstand. Slå den til, og få vist nye ansigter i din valgte by.",
      "Hvordan bruger jeg Rejse-tilstand?",
      "Stort set – vi har et par sikkerhedsbegrænsninger, der kan ændre sig med tiden, men Rejse-tilstand er tilgængelig for de fleste destinationer.",
      "Kan jeg bruge Rejse-tilstand overalt?",
      "Rejse-tilstand vil vise din lokation som centrum af den valgte by, så nye forbindelser i området kan finde dig. De vil se en note på din profil om, at du er i Rejse-tilstand, så de ved, at du er på besøg, eller at du planlægger et besøg.",
      "Pakker du kufferten til en ferie, eller skal du på en forretningsrejse til en ny by? Slå Rejse-tilstand til i Bumble for at tage dit datingliv med på farten.",
      "Rejse-tilstand på Bumble",
      "Rejse-tilstand er dit ultimative værktøj til at skabe forbindelser, mens du er væk. Indstil din lokation til hvor som helst i verden, og din profil vil blive vist i den by, du vælger. Det betyder, at du kan få adgang til datingverdenen, uanset hvor du tager på eventyr henne.",
      "Hvad er Rejse-tilstand?",
      "Ingen kender et sted bedre end de lokale. Rejse-tilstand kan hjælpe dig med at få forbindelse til de personer, der kan gøre din rejse ekstra speciel.",
      "Indstil din lokation til din rejsedestination op til 7 dage, før du rejser. På den måde kan du planlægge dates eller møde nye matches på forhånd.",
      "Tænk ud over badeferier – det kan være du besøger din hjemby til jul, rejser med dit arbejde eller udforsker en ny by. Find romance, uanset hvor du lander.",
      "Find de bedste lokale datesteder",
      "Tag på eventyr",
      "Skab forbindelser, der holder",
      "Årsager til at elske Rejse-tilstand",
      "Rejse-tilstand er tilgængelig for medlemmer på Bumble med <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} og {{service_level_lexeme_name_two}}</a>. Tryk på indstillingshjulet i øverste højre hjørne af din profil, og scroll ned, indtil du ser Rejse-tilstand. Vælg din nye lokation for at se personer i det område. Din profil vil give potentielle dates besked om, at du er i Rejse-tilstand.",
      "Hvordan fungerer Rejse-tilstand?",
      "Prøv det nu",
      "Her er det sexet at være venlig, her er du perfekt på din måde, og her kommer kvinder først. Altid.",
      "Stedet at tage det første skridt",
      "Sunde relationer er helt essentielle for at leve et positivt og produktivt liv. Bumble er designet til at hjælpe dig med at føle dig godt tilpas, mens du skaber dine forbindelser, uanset om du dater, leder efter venner eller udvider dit professionelle netværk.",
      "Sådan gør Bumble en forskel",
      "Vi går op i integritet, venlighed, lighed, selvsikkerhed og respekt på alle stadier af et forhold. Vi er ikke bare åbne overfor forskellige orienteringer, vi fejrer dem – uanset om du er her for at finde kærlighed eller bare vil have det sjovt.",
      "Bumbles værdier",
      "På Bumble er det kvinderne, der sætter tempoet ved at tage det første skridt eller oprette et Opening Move, som matches kan svare på. Vi bytter rundt på forældede kønsroller og sætter fokus på ligestilling fra begyndelsen.",
      "Hvordan fungerer Bumble",
      "Om os",
      "Download nu",
      "Det er bedre på appen.",
      "Funktioner som gør det sjovt og behageligt at date online",
      "12. februar 2024",
      "Sådan styrker I den følelsesmæssige intimitet i forholdet",
      "25. januar 2024",
      "Sådan bruger du Bumble, når du aldrig har brugt en datingapp før",
      "5. februar 2024",
      "Deception Detector™",
      "Interessante nyheder fra datingverdenen",
      "Sæt dating på pause med <b>Snooze-tilstand</b>. Når du er klar til at date igen, ved du, hvor vi er.",
      "Tag en pause",
      "Brug <b>videoopkald</b> og <b>audiochats</b> for at komme så tæt på IRL som muligt, uden at tage hjemmefra.",
      "Sæt lyd på",
      "Se mere",
      "Vælg <b>Opening Moves</b> for at invitere dit match til at starte chatten, så du ikke behøver at gøre det.",
      "Gør mindre, date mere",
      "Pak din kuffert, og match over hele verden med <b>Rejse-tilstand</b>.",
      "Tag os med",
      "Var du vild med profilen? Fortæl dem det med et <b>SuperSwipe</b>.",
      "Fang deres opmærksomhed",
      "Send nogle <b>komplimenter</b> til dem, så du skiller dig ud fra mængden.",
      "Få dem til at rødme",
      "Brug <b>Inkognito-tilstand</b> for at skjule din profil for din chef, familie eller ekskærester.",
      "Gå undercover",
      "Date på din måde",
      "Et par måneder senere mødte hun også en af sine brudepiger der.",
      "Hannah mødte sin mand på Bumble.",
      "Før de byggede deres tiny house sammen, mødtes Carène og You-Liang på Bumble, hvor You-Liang blev nysgerrig på Carènes rejsebilleder.",
      "Carène og You-Liang",
      "Brian og Kaci var udstationeret i udlandet sammen – men de mødte hinanden på Bumble",
      "Brian og Kaci",
      "Hvis det lykkedes for dem, kunne det også lykkes for dig",
      "Tag det næste skridt",
      "Se det nye",
      "Du fortjener det bedste. Derfor har vi designet fantastiske måder du kan date mere og stresse mindre på.",
      "Sæt barren tilbage til der, hvor den skal være",
      "Om Bumble",
      "Vi er den eneste app, der gør dating bedre ved at tage udgangspunkt i kvinders oplevelse. For når ting er bedre for kvinder, er de bedre for alle.",
      "Make the first move™",
      "Find en, du har lyst til at date, og tag så det første skridt. Skab stærke forbindelser, find det I har tilfælles, og – som det allervigtigste – hav det sjovt.",
      "Mød nogen med Bumble Date",
      "Find venner, der hjælper din karriere på vej. Mød andre professionelle for at finde dit næste job, en mentor eller en helt ny karriere.",
      "Giv din karriere et skub med Bumble Bizz",
      "Mød nogen ligesom dig. Eller helt anderledes end dig. Få nye venner, og find ting at lave sammen – uanset om det er ude eller hjemme.",
      "Find nye venner på Bumble For Friends",
      "Vi har ikke kun fokus på dating",
      "Bumble er datingappen, hvor kvinder tager det første skridt. Det er appen, der ændrede måden, som folk dater, skaber meningsfulde relationer og bygger netværk på. Download nu.",
      "Bumble på {{social_network}}",
      "Se mere",
      "Download Bumble-appen fra App Store eller Google Play, og log ind med samme konto, du brugte på Bumble web.{{__EOL__}}{{__EOL__}}Scan QR-koden nedenfor med din telefon eller tablet for at komme i gang.{{__EOL__}}{{__EOL__}}Dine matches og samtaler venter på dig i appen. 💛",
      "Få appen",
      "Bumble er nu kun i appen, så vi kan fortsætte med at give dig den bedste oplevelse og de bedste sikkerhedsfunktioner.",
      "Bumble er nu kun i appen.",
      "Gå aldrig glip af en kontakt",
      "Ring uden at dele dit nummer",
      "Stol på, at dine matches er ægte",
      "Få notifikationer i realtid, så du ikke går glip af en besked.",
      "Brug vores tale- og videoopkald i appen for at gå fra match til fysisk møde\npå en sikker måde.",
      "Chat sikkert med verificerede medlemmer ved at bruge den nemme billed- og ID-verificering i appen.",
      "Hvorfor skifte til Bumble-appen?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Beklager, men vi kan ikke finde den side, du ledte efter.",
      "Kontakt us",
      "Hovsa, noget gik galt",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Premium",
      "Bumble - Blog",
      "Jobmuligheder",
      "Chat",
      "Byer",
      "Administrer Cookies",
      "Copyright © 2006 – til nu. Bumble. Alle rettigheder forbeholdes.",
      "Rapport: Dating med tillid",
      "Apple og Apple-logoet er varemærker tilhørende Apple Inc.{{__EOL__}}Google Play er et varemærke tilhørende Google LLC.",
      "Download",
      "Facebook",
      "Følg os",
      "Help Center",
      "Instagram",
      "Sprog",
      "LinkedIn",
      "Bumble er en del af Inc.",
      "Privatlivspolitik",
      "Safety Centre",
      "Sitemap",
      "Modern Slavery Act statement",
      "Vilkår og betingelser",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "komplimenter",
                  "komplimenters"
            ],
            "singular": [
                  "kompliment",
                  "kompliments"
            ]
      },
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes",
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe",
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
